<template lang="html">
  <v-flex offset-xs1 xs10 offset-sm1 sm10 offset-md1 md10 class="schedule-list">
    <v-container grid-list-xl pa-0 fluid>
      <v-layout row wrap>
        <v-flex xs12 sm6 md4 v-for="schedule of filteredSchedule" :key="schedule.id">
          <schedule :value="schedule"></schedule>
        </v-flex>
      </v-layout>
    </v-container>
  </v-flex>
</template>

<script>
import Schedule from '../Schedule'
import moment from 'moment'
export default {
  name: 'schedules-list',
  components: {
    'schedule': Schedule
  },
  computed: {
    filteredSchedule () {
      if (this.searchSchedule === '') {
        return this.tabSchedule
      } else {
        return this.tabSchedule.filter(elem => {
          let exp = new RegExp(this.searchSchedule.trim(), 'i')
          let searchItem = elem.code +
            elem.condominium.name +
            elem.condominium.address +
            elem.condominium.addressNumber +
            elem.condominium.neighborhood +
            elem.condominium.city +
            elem.condominium.state +
            elem.condominium.administrator +
            elem.controlNumber +
            moment(elem.date).format('DD/MM/YYYY')
          return exp.test(searchItem)
        })
      }
    },
    searchSchedule () {
      return this.$store.getters.searchSchedule
    }
  }
}
</script>

<style>
.schedule-list .container.grid-list-xl .layout:not(:only-child){
  margin: -12px!important;
}
</style>



// WEBPACK FOOTER //
// index.vue?0d503daa